// src/index.ts
import axios3 from "axios";

// src/tokenRequester.ts
import axios from "axios";
var tokens = {};
function handleTokenFailure(response, tokenRequestUrl) {
  tokens[tokenRequestUrl] = void 0;
  console.error("Could not acquire an e-conomic api authentication token", response.message);
  throw response;
}
function tokenRequester(tokenRequestUrl, tokenTimeout) {
  const now = (/* @__PURE__ */ new Date()).getTime();
  const currentToken = tokens[tokenRequestUrl];
  const hasToken = currentToken?.authTokenPromise;
  const isExpired = hasToken && (now >= currentToken.authTokenExpirationTime || !currentToken.authTokenExpirationTime);
  if (!hasToken || isExpired) {
    tokens[tokenRequestUrl] = {
      authTokenExpirationTime: new Date(now + tokenTimeout * 0.9 * 60 * 1e3),
      authTokenPromise: axios.get(`${tokenRequestUrl}/?t=${now}`).then((response) => response.data).catch((error) => handleTokenFailure(error, tokenRequestUrl))
    };
  }
  return tokens[tokenRequestUrl].authTokenPromise;
}

// src/xsrfTokenRequester.ts
import axios2 from "axios";

// src/getCookieValue.ts
var getCookieValue = (name) => {
  const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
  return match ? match.pop() : "";
};

// src/xsrfTokenRequester.ts
var xsrfPromise;
function handleXsrfTokenFailure(response) {
  xsrfPromise = void 0;
  console.error("Could not acquire an e-conomic api XSRF token", response.message);
  throw response;
}
var XSRF_HEADER_NAME = "economic-xsrf";
var XSRF_COOKIE_NAME = "economic-xsrf-vrfy";
function xsrfTokenRequester(restURL) {
  if (xsrfPromise)
    return xsrfPromise;
  const xsrfCookie = getCookieValue(XSRF_COOKIE_NAME);
  if (xsrfCookie)
    return Promise.resolve(xsrfCookie);
  const response = axios2.get(`${restURL}/internal-api/application/anti-forgery`).then((response2) => response2.data).catch(handleXsrfTokenFailure);
  xsrfPromise = response;
  return response;
}

// src/createJsonPatchOperation.ts
function isValidJsonPatchOperation(op) {
  switch (op) {
    case "add":
    case "remove":
    case "replace":
    case "move":
    case "copy":
    case "test":
      return true;
    default:
  }
  return false;
}
function createJsonPatchOperation(op, path, value) {
  if (!isValidJsonPatchOperation(op)) {
    throw new Error(
      `http-client: '${op}' is not a valid JSON Patch operation. Use one of: add, remove, replace, move, copy, test.`
    );
  }
  if (!path.startsWith("/")) {
    throw new Error(`http-client: '${path}' is not a valid JSON Patch path. A JSON Patch path should start with '/'.`);
  }
  return { op, path, value };
}

// src/index.ts
function createClient(baseURL, optionsOrUrl, restURL = baseURL) {
  const client = axios3.create({
    baseURL,
    xsrfHeaderName: XSRF_HEADER_NAME,
    xsrfCookieName: XSRF_COOKIE_NAME
  });
  const tokenOptions = {
    url: typeof optionsOrUrl === "string" ? optionsOrUrl : null,
    headerKey: "X-EconomicToken",
    tokenName: "",
    tokenTimeout: 62,
    ...typeof optionsOrUrl === "object" ? { ...optionsOrUrl } : {}
  };
  if (tokenOptions.url) {
    client.interceptors.request.use(async (config) => {
      const token = await tokenRequester(tokenOptions.url, tokenOptions.tokenTimeout);
      config.headers[tokenOptions.headerKey] = tokenOptions.tokenName + token;
      return config;
    }, Promise.reject);
  }
  client.interceptors.request.use((config) => {
    const xsrfCookie = getCookieValue(XSRF_COOKIE_NAME);
    if (xsrfCookie)
      return config;
    return xsrfTokenRequester(restURL).then(() => config);
  }, Promise.reject);
  return client;
}

// index.ts
var http_client_default = createClient;
export {
  XSRF_COOKIE_NAME,
  XSRF_HEADER_NAME,
  createJsonPatchOperation,
  http_client_default as default,
  getCookieValue,
  xsrfTokenRequester
};
//# sourceMappingURL=index.esm.js.map